import { getAuthTokenAsync } from "src/store/common";
import * as api from "./api";

export const fetchData = async () => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(`${process.env.REACT_APP_ADMIN_API_URL}`);
  return response;
};

export const fetchSubscriptionList = async () => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/setting`,
  );
  return response;
};

export const updateSubscription = async (data: any) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.put(
    `${process.env.REACT_APP_ADMIN_API_URL}/setting/${data.seId}`,
    data,
  );
  return response;
};
